export const PRIVACY_POLICY_META_DESCRIPTION =
	'Privacy-Policy for AngelOne Fincap Private Limited—RBI-registered NBFC offering loan against securities (LAS), loans against stocks and ETFs, and loans against mutual funds (LAMF).';
